import { connect } from 'react-redux';
import updateCSS from 'shared/utils/update-css';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import WixSDK from 'shared/utils/wix-sdk';
import { getCompId } from 'shared/utils/comp-id';

import { getAllSettings } from 'shared/selectors/app-settings';

import updateAppSettings from 'widget/redux/client/actions/app-settings/update';

import DataComponent from 'shared/data-components/_data-component';


@connect(state => ({
  appSettings: getAllSettings(state),
}), {
  updateAppSettings,
})
export default class AppSettingsLoader extends DataComponent {

  static displayName = 'AppSettingsLoader';
  static propTypes = {
    updateAppSettings: React.PropTypes.func,
  };

  @autobind
  @debounce
  handleEditModeChanging({ editMode }) {
    this.props.updateAppSettings({ editMode });
  }

  @autobind
  @debounce
  handleSettingsChanging(styles) {
    styles = _.clone(styles);

    _.forEach(['colors', 'fonts'], function (prop) {
      styles[prop] = styles[prop] || {};

      try {
        const text = document.getElementById(`default-${prop}`).innerHTML
          .replace('/*', '')
          .replace('*/', '')
          .replace(/'.*?'/g, o => o.replace(/"/g, '\\"'))
          .replace(/'/g, '"');

        const obj = JSON.parse(text);
        _.forEach(obj, function (value, key) {
          styles[prop][key] = value;
        });
      } catch (error) {
        // do nothing
      }
    });

    updateCSS(styles);
    this.props.updateAppSettings(styles);
  }

  componentDidMount() {
    const { updateAppSettings } = this.props;

    const compId = getCompId();

    Promise.all([
        WixSDK.Styles.getStyleParams(),
        WixSDK.Settings.getSiteInfo(),
      ])
      .then(([styles, { url }]) => {
        updateAppSettings({
          ...styles,
          compId,
          siteUrl: url,
          instance: WixSDK.Utils.getInstance(),
          editMode: WixSDK.Utils.getViewMode(),
        });

        this.handleSettingsChanging(styles);

        WixSDK.addEventListener(WixSDK.Events.STYLE_PARAMS_CHANGE, this.handleSettingsChanging);
        WixSDK.addEventListener(WixSDK.Events.EDIT_MODE_CHANGE, this.handleEditModeChanging);
      });
  }

  componentWillUnmount() {
    WixSDK.removeEventListener(WixSDK.Events.STYLE_PARAMS_CHANGE, this.handleSettingsChanging);
    WixSDK.removeEventListener(WixSDK.Events.EDIT_MODE_CHANGE, this.handleEditModeChanging);
  }

  get childProps() {
    const { appSettings } = this.props;
    return { appSettings };
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/app-settings.js